import React, { useEffect, useState } from 'react';
import AppHeader from '../../component/AppHeader/app-header';
import Stepper from '../../component/Stepper/Stepper';
import BillingForm from './components/BillingForm';
import OrderSummary from './components/OrderSummary';
import './Checkout.scss';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useStepper } from '../../hooks/useStepper';
import { useSearchParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { fetchSubscriptionPlans } from '../../services/subscription';
import { setBillingType, setPlan } from '../../store/reducers/subscriptionSlice/subscriptionSlice';
import PageLoader from '../../component/PageLoader';

const CheckoutPage = () => {
	const { steps, currentStep, goToStep } = useStepper();
	const navigate = useNavigate();
	const [restoring, setRestoring] = useState(true);
	const dispatch = useDispatch();
	const [searchParams] = useSearchParams();
	const planKey = searchParams.get('plan');
	const billing = searchParams.get('billing');
	const { selectedPlan } = useSelector((state) => state.subscription);

	const subscription = useSelector(
		(state) => state.userInfo?.userInfo?.data?.subscription
	);

	useEffect(() => {
		if (
			subscription?.is_active &&
			subscription?.status === "active"
		) {
			navigate("/payment-success", {
				replace: true,
			});
			return;
		}

		if (!selectedPlan && !planKey) {
			navigate("/subscription-plan", {
				replace: true,
			});
		}
	}, [
		subscription,
		selectedPlan,
		planKey,
		navigate,
	]);

	useEffect(() => {
		const restorePlan = async () => {
			try {
				if (selectedPlan) {
					setRestoring(false);
					return;
				}

				if (!planKey) {
					setRestoring(false);
					return;
				}

				const response = await fetchSubscriptionPlans();

				const plan = response?.plans?.find((item) => item.key === planKey);

				if (!plan) {
					setRestoring(false);
					return;
				}

				dispatch(
					setPlan({
						id: plan._id,
						key: plan.key,
						title: plan.name,
						description: plan.meta?.description,
						billing: plan.billing || [],
					}),
				);

				dispatch(setBillingType(billing || 'monthly'));
			} catch (error) {
			} finally {
				setRestoring(false);
			}
		};

		restorePlan();
	}, [planKey, billing, selectedPlan, dispatch]);

	if (restoring) {
		return <PageLoader />;
	}

	return (
		<>
			<AppHeader title="Complete Checkout" />
			<main className="main-wrapper">
				<div className="pb-4">
					<Stepper
						steps={steps}
						currentStep={currentStep}
						onStepClick={goToStep}
					/>
				</div>
				<div className="pb-5">
					<div className="checkout-container">
						<div className="checkout-grid">
							<div className="checkout-left">
								<BillingForm />
							</div>

							<div className="checkout-right">
								<OrderSummary />
							</div>
						</div>
					</div>
				</div>
			</main>
		</>
	);
};

export default CheckoutPage;
